class LocalStorage {
  static getItem(key) {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      
      return null;
    }
  }

  static setItem(key, value) {
    try {
      localStorage.setItem(key, value);
      return true;
    } catch (error) {
      
      return false;
    }
  }

  static removeItem(key) {
    try {
      localStorage.removeItem(key);
      return true;
    } catch (error) {
      
      return false;
    }
  }

  static getObject(key) {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      
      return null;
    }
  }

  static setObject(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (error) {
      
      return false;
    }
  }

  static getUserSpecificKey(baseKey, userId) {
    return userId ? `${baseKey}_${userId}` : baseKey;
  }

  static clear() {
    try {
      localStorage.clear();
      return true;
    }

    catch (error) {
      
      return false;
    }
  }
}

export default LocalStorage;
